export const userSelectNoneStyle = `
  user-select: none;
`;